import { render, staticRenderFns } from "./AdminDropdownFiltreCouleurs.vue?vue&type=template&id=c38ef90a&"
import script from "./AdminDropdownFiltreCouleurs.vue?vue&type=script&lang=js&"
export * from "./AdminDropdownFiltreCouleurs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports